import React, { useContext, useState } from 'react'
import { Button, useOverlay, Paragraph } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { usePageTitle } from '../../app/PageTitleContext'
import { PermissionsContext } from '../../app/PermissionsContext'
import CmisRefAddDialog from './CmisAddDialog'
import useCmisReferences from '../../../hooks/useCmisReferences'
import { getCmisReferences as getUserCmisReferences } from '../../../services/userService'
import { getCmisReferences as getPersonCmisReferences } from '../../../services/personService'
import { PersonContext } from '../../person/PersonContext'
import { UserContext } from '../../user/UserContext'
import CmisReference from './CmisReference'

export default function CmisReferences({ match }) {
  usePageView({ page_detail: 'DMConsole:CmisReferences' })
  const { t } = useTranslation()
  const { isAuthorized } = useContext(PermissionsContext)
  const addDialogOpener = useOverlay()
  let pageType = null
  let pageContext = null
  let getCmisReferences = null
  let id = null
  let context = null
  let personDetails = null
  const [totalSelectedEntityRefIds, setTotalSelectedEntityRefIds] = useState([])

  if (match.url.includes('/person/')) {
    pageType = 'person'
    pageContext = PersonContext
  }
  if (match.url.includes('/user/')) {
    pageType = 'user'
    pageContext = UserContext
  }

  usePageTitle(t(pageType === 'person' ? 'pageTitle.person.references' : 'pageTitle.user.references'))

  const { currentUser, currentPerson, fetchCurrentUser, fetchCurrentPerson } = useContext(pageContext)

  const currentPersonUser = currentUser || currentPerson
  const fetchCurrentPersonUser = fetchCurrentUser || fetchCurrentPerson

  switch (pageType) {
    case 'user':
      {
        getCmisReferences = getUserCmisReferences
        if (currentPersonUser.dmcUserMembership?.cmisRefId) {
          id = currentPersonUser.dmcUserMembership.cmisRefId
          context = 'cmisId'
        } else if (currentPersonUser.dmcUser?.cisId) {
          id = currentPersonUser.dmcUser.cisId
          context = 'cisUserId'
        }

        // If there is no cisId, check how we got here
        if (!id) {
          id = currentPersonUser.input.userId
          context = currentPersonUser.input.context
        }
        const personIdItem = currentPersonUser.metadata.items.find((item) => item.field === 'pid')
        personDetails = {
          copyPersonName: currentPersonUser.metadata.header,
          copyPersonId: personIdItem?.value.value,
        }
      }
      break
    case 'person':
      getCmisReferences = getPersonCmisReferences
      id = currentPersonUser.id

      personDetails = {
        copyPersonName: currentPersonUser.name,
        copyPersonId: currentPersonUser.id,
      }
      break
    default:
      break
  }

  const { references } = useCmisReferences({ getCmisReferences, id, context })
  const noReferences = references && Object.keys(references.membershipSummaryMap).length === 0
  if (!currentPersonUser || !references) {
    return null
  }
  if (noReferences) {
    return (
      <>
        <Paragraph size="sm">{t('person.references.noCmisReferencesFound', 'No CMIS references found')}</Paragraph>
        <Button
          emphasis="medium"
          onClick={addDialogOpener.handleClick}
          disabled={!isAuthorized('CmisxCreateAnyCmisReferencePermission')}
        >
          {t('person.references.addReference', 'Add reference')}
        </Button>
        <CmisRefAddDialog personDetails={personDetails} onSubmit={fetchCurrentPersonUser} {...addDialogOpener} />
      </>
    )
  }

  return (
    <>
      {references.personCopies.map((personCopy, index) => (
        <CmisReference
          key={personCopy.copyPersonId}
          index={index}
          personCopy={personCopy}
          membershipSummaryMap={references.membershipSummaryMap}
          fetchCurrentPersonUser={fetchCurrentPersonUser}
          totalSelectedEntityRefIds={totalSelectedEntityRefIds}
          setTotalSelectedEntityRefIds={setTotalSelectedEntityRefIds}
        />
      ))}
    </>
  )
}
